import React from 'react';
import { getBackgroundPosition } from './utils';

interface BackgroundImageProps {
  enabled?: boolean;
  url?: string;
  cloudfrontUrl?: string;
  position?: string;
  size?: string;
  repeat?: string;
  parallax?: boolean;
  alt?: string;
  overlay?: {
    enabled?: boolean;
    color?: string;
    opacity?: number;
  };
}

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
  enabled,
  url,
  cloudfrontUrl,
  position,
  size = 'cover',
  parallax,
  alt,
  overlay,
}) => {
  if (!enabled || (!url && !cloudfrontUrl)) {
    return null;
  }

  const imageUrl = cloudfrontUrl || url || '';
  const rawSize = size || 'cover';
  const altText = alt || 'Countdown timer background';

  return (
    <>
      <div className={`absolute inset-0 overflow-hidden ${parallax ? 'parallax-bg' : ''}`}>
        <img
          src={imageUrl}
          alt={altText}
          data-seo-image-role="content"
          className="absolute inset-0 h-full w-full"
          style={{
            objectFit: rawSize === 'contain' ? 'contain' : 'cover',
            objectPosition: getBackgroundPosition(position),
          }}
        />
      </div>
      {overlay?.enabled && (
        <div
          className="absolute inset-0"
          style={{
            backgroundColor: overlay.color || '#000000',
            opacity: overlay.opacity ?? 0.5,
          }}
        />
      )}
    </>
  );
};
